import currencyFormatter from 'currency-formatter';

export default {
    methods: {
        _currency(value, currency = 'USD', showCurrency = true) {
            if (Number.isNaN(Number(value))) return value;
            value = Number.parseFloat(value);
        
            value = currencyFormatter.format(value, { code: currency, precision: 2 });
            if (showCurrency) value = `${value} ${currency}`;
            return value;
        }
    }
};
